import { render } from "./Certificate.vue?vue&type=template&id=29aa78bf&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=29aa78bf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-29aa78bf"

export default script